export const PRECONNECT = [
  'api.feefo.com',
  'googleads.g.doubleclick.net',
  'googletagmanager.com',
  'stats.g.doubleclick.net',
  'use.typekit.net',
  'www.google-analytics.com',
  'www.google.com',
  'www.googleadservices.com'
];
